import { render, staticRenderFns } from "./IntelligenceAgri.vue?vue&type=template&id=0d2ffa28&"
import script from "./IntelligenceAgri.vue?vue&type=script&lang=js&"
export * from "./IntelligenceAgri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports